var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrows = function SvgArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E73A4",
    d: "M10.676.671a1.155 1.155 0 0 1 0 1.543L6.684 6.532a.955.955 0 0 1-1.426 0L1.267 2.214a1.14 1.14 0 0 1-.296-.772c0-.278.099-.558.295-.77a.955.955 0 0 1 1.426 0l2.27 2.455 1.01 1.12 1.008-1.12L9.25.671a.955.955 0 0 1 1.426 0"
  })));
};
export default SvgArrows;